<template>
    <div class="app-container">
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12">
                <el-radio-group v-model="tabPosition" @change="handleBtnChange">
                    <el-radio-button :label="`${curYear - 3}`">{{ curYear - 3 }}</el-radio-button>
                    <el-radio-button :label="`${curYear - 2}`">{{ curYear - 2 }}</el-radio-button>
                    <el-radio-button :label="`${curYear - 1}`">{{ curYear - 1 }}</el-radio-button>
                    <el-radio-button :label="`${curYear}`">{{ curYear }}</el-radio-button>
                </el-radio-group>
            </el-col>
        </el-row>
        <div style="text-align: center; margin: 20px 0px 10px 0px">
            <span v-text-lbl="'JykTable.AnnualFuelCard'" class="statistics_title" style="text-align: center" :curYear1="curYear1">{{ curYear1 }}年加油卡消费统计</span>
        </div>
        <div v-show="tableData.length" id="mychart" ref="mychart" class="mychart" />
        <el-row class="btnpos" style="text-align: right; margin-bottom: 10px">
            <el-button v-if="show" :key="year" v-table-toxls="export_table" plain :file-name="$tx('clgl.tjbb.JykTable.AnnualFuelCard', { curYear1: curYear1 }, `${curYear1}年加油卡消费统计`)">
                <svg-icon icon-class="export" />
                <span v-pageBtn-lbl="'export'">导出</span>
            </el-button>
        </el-row>
        <!-- 表格 -->
        <div class="table-wrap">
            <el-table id="export_table" ref="multipleTable" :data="tableData" border style="width: 100%" :span-method="arraySpanMethod" :cell-style="changeStyleHandler">
                <el-table-column :label="$tx('fields.index', '序号')" type="index" width="55" align="center" />
                <!-- <el-table-column
          :label="机构名称"
          width=""
          prop="orgName"
          align="left"
        /> -->
                <el-table-column :label="$tx('clgl.tjbb.JykTable.cardNumber', '加油卡号')" width="" prop="cardNumber" align="left" />
                <el-table-column prop="1" :label="$tx('clgl.tjbb.JykTable.one', '1月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.one'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">1月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="2" :label="$tx('clgl.tjbb.JykTable.two', '2月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.two'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">2月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="3" :label="$tx('clgl.tjbb.JykTable.three', '3月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.three'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">3月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="4" :label="$tx('clgl.tjbb.JykTable.four', '4月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.four'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">4月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="5" :label="$tx('clgl.tjbb.JykTable.five', '5月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.five'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">5月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="6" :label="$tx('clgl.tjbb.JykTable.six', '6月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.six'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">6月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="7" :label="$tx('clgl.tjbb.JykTable.seven', '7月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.seven'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">7月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="8" :label="$tx('clgl.tjbb.JykTable.eight', '8月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.eight'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">8月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="9" :label="$tx('clgl.tjbb.JykTable.nine', '9月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.nine'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">9月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="10" :label="$tx('clgl.tjbb.JykTable.ten', '10月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.ten'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">10月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="11" :label="$tx('clgl.tjbb.JykTable.eleven', '11月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.eleven'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">11月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="12" :label="$tx('clgl.tjbb.JykTable.twelve', '12月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.twelve'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">12月</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$tx('clgl.tjbb.JykTable.total', '合计(元)')" width="120" prop="total" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.total'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">合计(元)</div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="pager-wrap">
        <el-pagination

          :hide-on-single-page="hiddenPageFlag"
          :current-page="currentPage"
          :page-sizes="[2,10,20,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dataTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div> -->
        </div>
    </div>
    <!-- v-if="changeFlag=='chart'" -->
</template>

<script>
import { mapGetters } from 'vuex'
import * as echarts from 'echarts'

export default {
    components: {},
    props: [],
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'tjbb',
            hiddenPageFlag: false,
            pageSize: 2,
            currentPage: 1,
            dataTotal: '',
            changeFlag: 'table',
            tabPosition: '',
            curYear: '',
            allData: [],
            tableData: [],
            tableData_m: [],
            listdata1: [],
            listdata2: [],
            listdata3: [],
            listdata4: [],
            allres: [],
            flag: false,
            curYear1: '',
            num: 0,
            loginUser: this.$store.getters.loginUser,
            show: true
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        curYear1(val) {
            this.show = false
            this.curYear1 = val
            this.$nextTick(() => {
                this.show = true
            })
        }
    },
    created() {
        this.$bus.emit('showNavSearch', false) // 搜索去掉
        const d = new Date()
        this.curYear = d.getFullYear()
        this.tabPosition = this.curYear
        this.getdata()
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按
        // if (document.querySelector('.dwyc')) {
        //     document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'block'
        // }
    },
    mounted() {
        // if (document.querySelector('.dwyc')) {
        //     document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'none'
        // }
    },
    methods: {
        changeStyleHandler(row, index) {
            // console.log(row, index)
            if (row.rowIndex === this.tableData.length - 1 && row.columnIndex === 1) {
                return {
                    textAlign: 'center'
                }
            }
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = this.$tx('clgl.tjbb.totalPrice', '总价')
                    return
                }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                    sums[index] += '.00'
                } else {
                    sums[index] = ''
                }
            })
            sums[1] = ''
            return sums
        },
        handleCurrentChange(v) {
            this.currentPage = v
            const startIndex = (this.currentPage - 1) * this.pageSize
            const endIndex = startIndex + this.pageSize
            this.tableData = this.tableData_m.slice(startIndex, endIndex)
        },
        handleSizeChange(v) {
            this.pageSize = v
            const startIndex = (this.currentPage - 1) * this.pageSize
            const endIndex = startIndex + this.pageSize
            this.tableData = this.tableData_m.slice(startIndex, endIndex)
            if (parseInt(this.dataTotal / this.pageSize) === 0) {
                this.showPageFlag = false
            }
        },

        // 行合并
        // arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        //     console.log('this.tableData.length:', this.tableData.length)

        //     if (rowIndex === 4) {
        //         if (columnIndex === 0) {
        //             return [1, 2]
        //         } else if (columnIndex === 1) {
        //             return [0, 0]
        //         }
        //     }
        // },
        // 列表
        changeToList() {
            this.changeFlag = 'table'
        },
        // 图表
        changeToChart() {
            let listdataTmp = {}
            switch (parseInt(this.tabPosition)) {
                case parseInt(this.curYear):
                    listdataTmp = this.listdata1
                    break
                case parseInt(this.curYear) - 1:
                    listdataTmp = this.listdata2
                    break
                case parseInt(this.curYear) - 2:
                    listdataTmp = this.listdata3
                    break
                case parseInt(this.curYear) - 3:
                    listdataTmp = this.listdata4
                    break
                // default:
                //     listdataTmp = this.listdata1
            }

            const xdata = []
            const data = []
            listdataTmp.forEach((item) => {
                xdata.push(item.cardNumber)
                data.push(item.total)
            })
            this.$nextTick(() => {
                this.initCharts(xdata, data)
            })
        },
        initCharts(xdata, data) {
            // 基于准备好的dom，初始化echarts实例
            const myCharts = echarts.init(document.getElementById('mychart'))
            setTimeout(function () {
                window.onresize = function () {
                    myCharts.resize()
                }
            })
            // 绘制图表
            myCharts.setOption({
                tooltip: {},
                grid: {
                    left: '5%',
                    right: '6%',
                    top: '8%',
                    bottom: '8%'
                },
                xAxis: {
                    name: '加油卡号',
                    nameTextStyle: {
                        fontSize: 12,
                        color: '#eeeee'
                    },
                    data: xdata,
                    // position: 'bottpm',
                    // nameLocation: 'middle',
                    // nameGap: 30,
                    // nameRotate: 0
                    align: 'end'
                },
                yAxis: {
                    name: this.curYear1 + '年消费费用（元）',
                    type: 'value',
                    nameTextStyle: {
                        fontSize: 12,
                        padding: [0, 0, 0, 120],
                        color: '#eeeee'
                    },
                    axisLabel: {
                        formatter: '{value}'
                    },
                    gridIndex: 0,
                    position: 'left',
                    nameLocation: 'end',
                    nameGap: 5,
                    nameRotate: 0,
                    // 显示y轴
                    axisLine: {
                        show: true
                    }
                },
                series: [
                    {
                        name: '加油卡消费费用',
                        type: 'bar',
                        data: data,
                        barWidth: 70,
                        itemStyle: {
                            normal: {
                                // 定义一个list，然后根据所以取得不同的值，这样就实现了，
                                color: '#1E90FF'
                            }
                        }
                    }
                ]
            })
        },
        // 切换年份，数据改变
        handleBtnChange(v) {
            if (!v) {
                v = this.curYear
                this.changeToChart()
            }
            // this.$http({
            //     url: '/clgl/tjb/getJykxfStatistics',
            //     method: 'POST',
            //     contentType: 'application/x-www-form-urlencoded',
            //     params: {
            //         'time': v
            //     }
            // }).then(res => {
            //     if (res.code === 'success') {
            //         console.log('11111111111')
            //     }
            // })
            const d = new Date()
            const curYear = d.getFullYear()
            if (parseInt(v) === curYear) {
                this.tableData = this.listdata1
                this.curYear1 = v
                this.changeToChart()
            } else if (parseInt(v) === parseInt(curYear) - 1) {
                this.tableData = this.listdata2
                this.curYear1 = v
                this.changeToChart()
            } else if (parseInt(v) === curYear - 2) {
                this.tableData = this.listdata3
                this.curYear1 = v
                this.changeToChart()
            } else if (parseInt(v) === curYear - 3) {
                this.tableData = this.listdata4
                this.curYear1 = v
                this.changeToChart()
            }
            this.dataTotal = this.tableData.length
            this.tableData_m = this.tableData
            // if (parseInt(this.dataTotal / this.pageSize) === 0) {
            //     // this.hiddenPageFlag = true
            //     // 控制分页是否显示
            // }
            this.currentPage = 1
            // this.pageSize = 2
            // const startIndex = (this.currentPage - 1) * this.pageSize
            // const endIndex = (startIndex + this.pageSize)
            // if (this.tableData.length >= endIndex) {
            //     this.tableData = this.tableData.slice(startIndex, endIndex)
            // }
            this.tableData.length > 0 ? this.changeToChart() : ''
            const copydata = JSON.parse(JSON.stringify(this.tableData))
            const lastrow = { cardNumber: this.$tx('clgl.tjbb.hj', '合计'), total: 0 }
            copydata.forEach((item) => {
                console.log(item)
                lastrow.total += Number(item.total)
            })
            lastrow.total = lastrow.total.toFixed(2)
            copydata.push(lastrow)
            this.tableData = copydata
            console.log(this.tableData)
        },
        arraySpanMethod(events) {
            if (events.rowIndex === this.tableData.length - 1) {
                if (events.columnIndex === 0) {
                    return [0, 0]
                } else if (events.columnIndex === 1) {
                    return [1, 2]
                } else if (events.columnIndex !== 14) {
                    return [0, 0]
                } else {
                    return [1, 13]
                }
            }
        },
        // getCarInfo() {
        //     this.$http({
        //         url: '/clgl/tjb/getJykxfStatistics',
        //         method: 'POST',
        //         contentType: 'application/x-www-form-urlencoded',
        //         params: {
        //             'time': this.curYear
        //         }
        //     }).then(res => {
        //         if (res.code === 'success') {
        //             console.log(res.body.listdata)
        //         }
        //     })
        // },
        async getdata() {
            const param = {
                orderBy: 'carNumber asc',
                urlsearch: `orgCode:${this.loginUser.orgCode}`
            }
            const res = await this.$app.listdata('/clgl/jykxf/listdata', param)
            // this.$http({
            //     url: '/clgl/jykxf/listdata',
            //     method: 'POST',
            //     contentType: 'application/x-www-form-urlencoded',
            //     params: { orderBy: 'cardNumber asc' },
            //     data: [
            //         {
            //             'compare': '=',
            //             'field': 'orgCode',
            //             'merge': false,
            //             'value': this.loginUser.orgCode
            //         }
            //     ]
            // }).then(res => {
            // console.log('res:', res)
            var numRmb = 0
            if (res.code === 'success') {
                this.allres = res.body.pageInfo.list
                this.allres.forEach((item) => {
                    console.log(item)
                    const item_tmp = {}
                    item_tmp.cardNumber = item.cardNumber
                    item_tmp.orgName = item.orgName
                    const d = new Date(item.consumeDate)
                    item_tmp.year = parseInt(d.getFullYear())
                    item_tmp.month = parseInt(d.getMonth()) + 1
                    item_tmp.consumeAmount = item.consumeAmount
                    this.allData.push(item_tmp)
                    numRmb += item.consumeAmount
                })
                this.allres.push({ cardNumber: this.$tx('clgl.tjbb.hj', '合计'), total: numRmb.toFixed(2) })
                this.allData.forEach((item2) => {
                    if (item2.year === this.curYear) {
                        //    let item_tmp={};
                        //    item_tmp
                        if (this.listdata1 !== []) {
                            let flag = 0
                            this.listdata1.forEach((item11) => {
                                if (item11.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item11[item2.month]) {
                                        item11[item2.month] += parseInt(item2.consumeAmount)
                                    } else {
                                        item11[item2.month] = parseInt(item2.consumeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.consumeAmount)
                                this.listdata1.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.consumeAmount)
                            this.listdata1.push(item_tmp)
                        }

                        this.listdata1.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 1) {
                        //    let item_tmp={};
                        //    item_tmp
                        if (this.listdata2 !== []) {
                            let flag = 0
                            this.listdata2.forEach((item22) => {
                                if (item22.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item22[item2.month]) {
                                        item22[item2.month] += parseInt(item2.consumeAmount)
                                    } else {
                                        item22[item2.month] = parseInt(item2.consumeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.consumeAmount)
                                this.listdata2.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.consumeAmount)
                            this.listdata2.push(item_tmp)
                        }

                        this.listdata2.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total = parseInt(item.total) + parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 2) {
                        //    let item_tmp={};
                        //    item_tmp
                        if (this.listdata3 !== []) {
                            let flag = 0
                            this.listdata3.forEach((item33) => {
                                if (item33.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item33[item2.month]) {
                                        item33[item2.month] += parseInt(item2.consumeAmount)
                                    } else {
                                        item33[item2.month] = parseInt(item2.consumeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.consumeAmount)
                                this.listdata3.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.consumeAmount)
                            this.listdata3.push(item_tmp)
                        }

                        this.listdata3.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 3) {
                        //    let item_tmp={};
                        //    item_tmp
                        if (this.listdata4 !== []) {
                            let flag = 0
                            this.listdata4.forEach((item44) => {
                                if (item44.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item44[item2.month]) {
                                        item44[item2.month] += parseInt(item2.consumeAmount)
                                    } else {
                                        item44[item2.month] = parseInt(item2.consumeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.consumeAmount)
                                this.listdata4.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.consumeAmount)
                            this.listdata4.push(item_tmp)
                        }

                        this.listdata4.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    }
                })
                this.listdata1.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata2.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata3.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata4.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                if (!this.flag) {
                    this.flag = true
                    this.handleBtnChange()
                }
            }
            // })
        }
    }
}
</script>

<style scoped lang="scss">
//   height:800px;
.pager-wrap {
    text-align: right;
    margin-top: 5px;
}
//    border:1px solid red;
.row-bg {
    height: 40px;
    line-height: 40px;
    //    border:1px solid red;
    margin-bottom: 3px;
    .btnpos {
        text-align: right;
    }
}
.table-wrap {
    width: 100%;
}
.mychart {
    //  width:1805px;
    width: 88vw;
    height: 300px;
    // border:1px solid red
    margin: 0 auto;
    margin: 0px 0px 20px -8px;
}
/deep/ .el-table .cell {
    text-align: center;
}
.dwyc .el-date-editor .el-range-separator {
    width: 6%;
}
</style>
